export default __webpack_public_path__ + "static/media/master.91f6ff9b.png";